"use client";

import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { Toaster } from "react-hot-toast";
import { CsatAuthProvider } from "../context/CsatAuthContext";
import { StorefrontProviders } from "./StorefrontProviders";

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  const pathname = usePathname();

  if (pathname.startsWith("/csat/")) {
    return (
      <CsatAuthProvider>
        {children}
        <Toaster />
      </CsatAuthProvider>
    );
  }

  return (
    <StorefrontProviders>{children}</StorefrontProviders>
  );
}
